import React from "react";
import { InputError } from "../labels";

const FormGroupInput = ({children, className, error}) => {
    return (
        <div className={`flex ${className}`}>
            {children}
            {error && <InputError error={error} />}
        </div>
    )
};

export default FormGroupInput;